import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

export default createAsyncActionTypes([
  'FETCH_PRODUCTS',
  'FETCH_PRODUCTS_START',
  'FETCH_PRODUCTS_SUCCESS',
  'FETCH_PRODUCTS_ERROR',
]);
